import { inject, Injectable } from '@angular/core';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { WorkOrdersService } from '@app/pages/cmms/services/work-orders.service';
import { TranslateService } from '@tolgee/ngx';

@Injectable({
	providedIn: 'root',
})
export class AttachedIncidentsService {
	private readonly workOrdersService = inject(WorkOrdersService);
	private readonly notify = inject(IconSnackBarService);
	private readonly translate = inject(TranslateService);
	unlinkIncidentFromWorkorder(workorderPk: string, incidentId: string[]) {
		this.workOrdersService
			.unlinkAttachedElementLists({
				pk: workorderPk,
				incidents: incidentId,
			})
			.subscribe({
				next: () => {
					this.notify.success(
						this.translate.instant('incidents_has_been_unlinked', {
							count: incidentId.length,
						})
					);
				},
				error: () => {
					this.notify.error(this.translate.instant('failted_to_unlink'));
				},
			});
	}
}
